<ng-container [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-delivery-notes-webshop *ngSwitchDefault></app-delivery-notes-webshop>
  <!-- <app-delivery-notes-old *ngSwitchCase="0"></app-delivery-notes-old> -->
</ng-container>
